export enum BANNER_CONDITIONS {
  MIGRATION = "migration",
}
